import React from "react";
import { default as MUIGrid } from "@mui/material/Grid";

export const Grid = (props) => {
  return <MUIGrid {...props} />;
};

export default Grid;
